export enum CodeType {
  Diagnosis,
  Procedure,
  Other
}
